// Feature-scoped string constants for SettingsModal

// Tab keys
export const LANGUAGE = 'language';
export const SETTINGS = 'settings';
export const HELP = 'help';
export const LOBBY = 'lobby';
export const DEPOSIT = 'deposit';
export const EXIT = 'exit';

// External message names
// fallow-ignore-next-line unused-export
export const MESSAGE_MUTE = 'mute';
